import {
  FormatData,
  DirectionPartD,
  Direction,
  CanvasIds,
  DotData,
  DrawCanvasProps,
  Point,
  Dot,
  Line,
  Circle,
  Text,
  ponintName,
} from "./postureData.type";
import { CanvasEnum } from "./muscle";
var _ = require("lodash");

export const formatData = (args: FormatData): Array<DotData> => {
  let sideDirection: any = "";
  let p = args.data;
  let direction = args.direction;
  let dataList: Array<DotData> = [];
  let points = JSON.parse(JSON.stringify(p.body?.front?.points || {}));
  if (direction == "front") {
  } else if (direction == "side") {
    points = JSON.parse(JSON.stringify(p.body?.side?.points || {}));
    sideDirection = p.body?.side?.side || "";
  } else if (direction == "otherSide") {
    points = JSON.parse(JSON.stringify(p.body?.otherSide?.points || {}));
    sideDirection = p.body?.otherSide?.side || "";
  } else if (direction == "back") {
    if (!p.body?.back) {
      p.body!.back = p.body?.front;
    }
    points = JSON.parse(JSON.stringify(p.body?.back?.points || {}));
  }

  function createDotData(x, y, D, part, d): DotData {
    let dot: DotData = Object.assign({
      position: { x: 0, y: 0 },
    });
    dot.position.x = x;
    dot.name = part;
    dot.position.y = y;
    dot.pointName = "";
    dot.part = part + d;
    dot.direction = D;
    dot.partDirection = d;
    dot.lineChildren = [];
    dot.horizotalLine = [];
    dot.verticalLine = [];
    dot.disabled = true;
    dot.hCalculateAngle = true;
    dot.dot = new Dot({ fillStyle: "#3B9EFF" });
    dot.circle = new Circle({ radius: 2, strokeStyle: "#3B9EFF" });
    dot.line = new Line({ strokeStyle: "#F5F5F8" });
    dot.vline = new Line({ strokeStyle: "#17CD98" });
    dot.hline = new Line({ strokeStyle: "#17CD98" });
    dot.text = new Text();

    if (D == "side" || D == "otherSide") {
      if (sideDirection.length) {
        if (dot.partDirection != sideDirection) {
          dot.disabled = false;
        } else {
          dot.disabled = true;
        }
      }
      if (dot.part == "nose") {
        dot.disabled = true;
      }
      if (dot.part == "neckcenter" || dot.part == "hipcenter") {
        dot.disabled = false;
      }
    }
    if (D == "back") {
      // 背面：眼睛、鼻子不绘制（只保留躯干与四肢轮廓）
      if (dot.part == "nose" || dot.part == "eyeleft" || dot.part == "eyeright") {
        dot.disabled = false;
      }
    }
    return dot;
  }

  function getPointByName(dataList: Array<DotData>, part: DirectionPartD): DotData {
    return dataList.filter((item) => {
      return item.part == part;
    })[0];
  }

  function createlineChildren(D: CanvasEnum, dataList: Array<DotData>): Array<DotData> {
    dataList = dataList.map((item) => {
      if (item.part == "nose") {
        item.lineChildren = [];
        item.lineChildren.push(
          getPointByName(dataList, "eyeleft"),
          getPointByName(dataList, "eyeright"),
          getPointByName(dataList, "neck")
        );
      }

      if (item.part == "eyeleft") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "earleft"));
      }
      if (item.part == "eyeright") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "earright"));
      }

      if (sideDirection.length) {
        if (item.part == "eyeright") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "earright"));
        }
        if (item.part == "eyeleft") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "earleft"));
        }
        if (item.part == "earright") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "shoulderright"));
        }
        if (item.part == "earleft") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "shoulderleft"));
        }
        if (item.part == "hipright") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "shoulderright"));
        }
        if (item.part == "hipleft") {
          item.lineChildren = [];
          item.lineChildren.push(getPointByName(dataList, "shoulderleft"));
        }
      }

      if (item.part == "neck") {
        item.lineChildren = [];
        item.lineChildren.push(
          getPointByName(dataList, "shoulderleft"),
          getPointByName(dataList, "shoulderright"),
          getPointByName(dataList, "shoulderright"),
          getPointByName(dataList, "neckcenter")
        );
      }
      if (item.part == "shoulderleft") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "elbowleft"));
      }
      if (item.part == "shoulderright") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "elbowright"));
      }
      if (item.part == "elbowleft") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "wristleft"));
      }
      if (item.part == "elbowright") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "wristright"));
      }
      if (item.part == "kneeleft") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "hipleft"), getPointByName(dataList, "ankleleft"));
      }
      if (item.part == "kneeright") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "hipright"), getPointByName(dataList, "ankleright"));
      }
      if (item.part == "heelleft") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "ankleleft"));
      }
      if (item.part == "heelright") {
        item.lineChildren = [];
        item.lineChildren.push(getPointByName(dataList, "ankleright"));
      }

      if (item.part == "hipcenter") {
        item.lineChildren = [];

        item.lineChildren.push(
          getPointByName(dataList, "hipleft"),
          getPointByName(dataList, "hipright"),
          getPointByName(dataList, "neckcenter")
        );
      }
      return item;
    });
    return dataList;
  }

  function createHorizotalLineChildren(D: CanvasEnum, dataList: Array<DotData>): Array<DotData> {
    dataList = dataList.map((item) => {
      if (D == "front") {
        if (item.part == "earleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "earleft");
          let earright = getPointByName(dataList, "earright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "shoulderleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "shoulderleft");
          let earright = getPointByName(dataList, "shoulderright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "hipleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "hipleft");
          let earright = getPointByName(dataList, "hipright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "kneeleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "kneeleft");
          let earright = getPointByName(dataList, "kneeright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "ankleleft") {
          item.horizotalLine = [];
          let ankleleft = getPointByName(dataList, "ankleleft");
          let ankleright = getPointByName(dataList, "ankleright");
          item.horizotalLine.push(ankleleft, ankleright);
        }
      }
      if (D == "back") {
        if (item.part == "earleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "earleft");
          let earright = getPointByName(dataList, "earright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "shoulderleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "shoulderleft");
          let earright = getPointByName(dataList, "shoulderright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "hipleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "hipleft");
          let earright = getPointByName(dataList, "hipright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "kneeleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "kneeleft");
          let earright = getPointByName(dataList, "kneeright");

          item.horizotalLine.push(earleft, earright);
        }
        if (item.part == "ankleleft") {
          item.horizotalLine = [];
          let ankleleft = getPointByName(dataList, "ankleleft");
          let ankleright = getPointByName(dataList, "ankleright");

          item.horizotalLine.push(ankleleft, ankleright);
        }
      }
      if (D == "side" || D == "otherSide") {
        if (item.part == "earleft") {
          item.horizotalLine = [];
          let earleft = getPointByName(dataList, "earleft");
          let shoulderleft = getPointByName(dataList, "shoulderleft");

          item.horizotalLine.push(earleft, shoulderleft);
        }
        if (item.part == "earright") {
          item.horizotalLine = [];
          let earright = getPointByName(dataList, "earright");
          let shoulderright = getPointByName(dataList, "shoulderright");

          item.horizotalLine.push(earright, shoulderright);
        }
        if (item.part == "hipright") {

            item.horizotalLine = []
            let hipright = getPointByName(dataList, "hipright")
            let kneeright = getPointByName(dataList, "hipright")

            item.horizotalLine.push(
                hipright,
                kneeright
            )
        }
        if (item.part == "hipleft") {

            item.horizotalLine = []
            let hipleft = getPointByName(dataList, "hipleft")
            let kneeleft = getPointByName(dataList, "hipleft")

            item.horizotalLine.push(
                hipleft,
                kneeleft
            )
        }
        if (item.part == "shoulderright") {
          item.horizotalLine = [];
          let shoulderright = getPointByName(dataList, "shoulderright");
          let elbowright = getPointByName(dataList, "elbowright");

          item.horizotalLine.push(shoulderright, elbowright);
        }
        if (item.part == "shoulderleft") {
          item.horizotalLine = [];
          let shoulderleft = getPointByName(dataList, "shoulderleft");
          let elbowleft = getPointByName(dataList, "elbowleft");

          item.horizotalLine.push(shoulderleft, elbowleft);
        }
      }
      return item;
    });
    if (D == "back") {
    }
    return dataList;
  }
  function createVerticalLineChildren(D: CanvasEnum, dataList: Array<DotData>): Array<DotData> {
    dataList = dataList.map((item) => {
      if (D == "front") {
        if (item.part == "shoulderleft") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "shoulderleft");
          item.verticalLine.push(verticalPoint);
        }
        if (item.part == "shoulderright") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "shoulderright");
          item.verticalLine.push(verticalPoint);
        }
        if (item.part == "nose") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "nose");
          item.verticalLine.push(verticalPoint);
        }
      }
      if (D == "back") {
        if (item.part == "shoulderleft") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "shoulderleft");
          item.verticalLine.push(verticalPoint);
        }
        if (item.part == "shoulderright") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "shoulderright");
          item.verticalLine.push(verticalPoint);
        }
        if (item.part == "nose") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "nose");
          item.verticalLine.push(verticalPoint);
        }
      }
      if (D == "side" || D == "otherSide") {
        console.log('[createVerticalLineChildren] Processing item:', item.part, 'direction:', D)
        
        if (item.part == "anklecenter") {
          item.disabled = false;
        }
        if (item.part == "ankleleft") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "ankleleft");
          console.log('[createVerticalLineChildren] ankleleft verticalPoint:', verticalPoint)
          if (verticalPoint) {
            item.verticalLine.push(verticalPoint);
          }
        }
        if (item.part == "ankleright") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "ankleright");
          console.log('[createVerticalLineChildren] ankleright verticalPoint:', verticalPoint)
          if (verticalPoint) {
            item.verticalLine.push(verticalPoint);
          }
        }
        if (item.part == "hipleft") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "hipleft");
          console.log('[createVerticalLineChildren] hipleft verticalPoint:', verticalPoint)
          if (verticalPoint) {
            item.verticalLine.push(verticalPoint);
          }
        }
        if (item.part == "hipright") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "hipright");
          console.log('[createVerticalLineChildren] hipright verticalPoint:', verticalPoint)
          if (verticalPoint) {
            item.verticalLine.push(verticalPoint);
          }
        }
        if (item.part == "nose") {
          item.verticalLine = [];
          let verticalPoint = getPointByName(dataList, "nose");
          console.log('[createVerticalLineChildren] nose verticalPoint:', verticalPoint)
          console.log('[createVerticalLineChildren] Before push, verticalLine length:', item.verticalLine.length)
          if (verticalPoint) {  // ✅ 只有在找到点时才添加
            item.verticalLine.push(verticalPoint);
          } else {
            console.warn('[createVerticalLineChildren] nose point not found in dataList for direction:', D)
          }
          console.log('[createVerticalLineChildren] After push, verticalLine:', item.verticalLine)
        }
      }
      return item;
    });
    return dataList;
  }
  for (let key in points) {
    let point = points[key];
    let part = key;
    if (key == "hip") {
      let x = 0;
      let y = 0;
      x = (points.hip.left.x + points.hip.right.x) / 2;
      y = (points.hip.left.y + points.hip.right.y) / 2;
      let hipcenter = createDotData(x, y, direction, "hipcenter", "");
      hipcenter.position.x && dataList.push(hipcenter);

      x = (x + points.neck.x) / 2;
      y = (y + points.neck.y) / 2;
      let neckcenter = createDotData(x, y, direction, "neckcenter", "");
      neckcenter.position.x && dataList.push(neckcenter);
    }
    // if (key = "ankle") {
    //     let x = 0;
    //     let y = 0;
    //     x = (points.ankle.left.x + points.ankle.right.x) / 2
    //     y = (points.ankle.left.y + points.ankle.right.y) / 2
    //     let anklecenter = createDotData(x, y, direction, "anklecenter", "")
    //     anklecenter.disabled = true
    //     anklecenter.position.x && dataList.push(anklecenter)
    // }
    if (point.x) {
      let p = createDotData(point.x, point.y, direction, part, "");
      p.position.x && dataList.push(p);
    } else {
      for (let d in point) {
        let p = createDotData(point[d].x, point[d].y, direction, part, d);
        p.position.x && dataList.push(p);
      }
    }
  }
  dataList = createlineChildren(direction, dataList);
  dataList = createHorizotalLineChildren(direction, dataList);
  dataList = createVerticalLineChildren(direction, dataList);
  return dataList;
};

var dataAngle = {};

export class PostureData {
  options: DrawCanvasProps;
  pointList: Array<DotData> = [];
  pointListOrig: Array<DotData> = [];
  risks: any = [];
  img: HTMLImageElement = Object.assign({});
  canvas: HTMLCanvasElement;
  canvasOrigHeight: number = 0;
  canvasOrigWidth: number = 0;
  ctx: CanvasRenderingContext2D = Object.assign({});
  scaleX: number = 1;
  scaleY: number = 1;
  scale: number = 2;
  scaleCtx: number = 1;
  angles = {};

  requestId: number = 0;
  isWheel: boolean = false;
  dis: number = 0;
  point: Point = {
    x: 0,
    y: 0,
  };
  constructor(args: DrawCanvasProps) {
    this.options = args;
    this.canvas = <HTMLCanvasElement>document.getElementById(args.canvasId);
    if (!this.canvas) return;
    this.ctx = <CanvasRenderingContext2D>this.canvas.getContext("2d");
    this.img = args.img;
    this.pointList = this.options.data;
    let arr = this.options.data;
    this.pointListOrig = _.cloneDeep(arr);
    this.risks = this.options.risks;
    if (args.width) {
      this.canvasOrigWidth = args.width;
    }
    if (args.height) {
      this.canvasOrigHeight = args.height;
    }
    this.initCanvas();
    this.initImg();
  }
  init = () => {
    this.initImg();
  };
  setScale = (scaleCtx: number = 1, isWheel: boolean) => {
    scaleCtx = +scaleCtx.toFixed(1);
    this.scaleCtx = scaleCtx;

    //画布 缩放
    let cssHeight = this.canvasOrigHeight;
    let cssWidth = (this.img.width / this.img.height) * cssHeight;

    cssWidth = +(cssWidth * scaleCtx).toFixed(1);
    cssHeight = +(cssHeight * scaleCtx).toFixed(1);

    this.canvas.style.width = cssWidth + "px";
    this.canvas.style.height = cssHeight + "px";
    this.canvas.width = cssWidth;
    this.canvas.height = cssHeight;

    //更新点坐标
    this.scaleX = this.canvas.width / this.img.width;
    this.scaleY = this.canvas.height / this.img.height;
    let pointListOrig = this.pointListOrig;
    let arr = _.cloneDeep(pointListOrig);
    this.updatePointList(arr);
    this.draw(false);
  };
  initCanvas = () => {
    this.canvas.addEventListener("mouseenter", this.mouseenter);
    this.canvas.addEventListener("mousemove", this.mousemove);
    this.canvas.addEventListener("mouseleave", this.mouseleave);
    this.canvas.addEventListener("mousedown", this.mousedown);
    this.canvas.addEventListener("mouseup", this.mouseup);
    this.canvas.addEventListener("redraw", this.redrawCanvas);
  };

  redrawCanvas = () => {
    this.draw(false);
  };
  hoverDot = () => {
    let dotList = this.pointList;
    let point = this.point;

    for (let i = 0; i < dotList.length; i++) {
      let x = dotList[i].position.x;
      let y = dotList[i].position.y;
      let dx = point.x - x;
      let dy = point.y - y;
      let res = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) < dotList[i].circle.radius * 2;

      if (res) {
        if (dotList[i].part.indexOf("center") >= 0 || this.options.canvasId.indexOf("big") < 0) {
        } else {
          dotList[i].hover = true;
        }
      } else {
        dotList[i].hover = false;
      }
    }
  };

  updatePoint = (e) => {
    let p = this.point;
    p.x = e.layerX; /// this.scaleCtx
    p.y = e.layerY; /// this.scaleCtx
    this.point = p;
  };
  mouseenter = (e) => {
    this.updatePoint(e);
    this.draw(true);
  };
  mousemove = (e) => {
    this.updatePoint(e);

    let pointList = this.pointList;
    pointList = pointList.map((item) => {
      if (item.select) {
        item.position.x = this.point.x;
        item.position.y = this.point.y;
      }
      return item;
    });
    this.pointList = pointList;
  };
  mousedown = (e) => {
    this.isWheel = false;
    let pointList = this.pointList;
    pointList = pointList.map((item) => {
      if (item.hover) {
        item.select = true;
      } else {
        item.select = false;
      }

      return item;
    });
    this.pointList = pointList;
  };
  updatePointList = (pointList) => {
    pointList = pointList.map((item) => {
      item.position.x = item.position.x * this.scaleX;
      item.position.y = item.position.y * this.scaleY;
      return item;
    });
    this.pointList = pointList.slice(0);
  };
  mouseup = (e) => {
    let pointList = this.pointList;
    pointList = pointList.map((item) => {
      item.select = false;

      return item;
    });
    this.pointList = pointList;
  };
  mouseleave = (e) => {
    cancelAnimationFrame(this.requestId);
  };
  formatAngle = (radian: string): string => {
    return ((parseFloat(radian) / Math.PI) * 180).toFixed(1);
  };
  initImg = () => {
    let devicePixelRatio =
      window.devicePixelRatio || window["webkitDevicePixelRatio"] || window["mozDevicePixelRatio"] || 1;

    let { width: cssWidth, height: cssHeight } = this.canvas.getBoundingClientRect();
    cssWidth = this.canvasOrigWidth || cssWidth;
    cssHeight = this.canvasOrigHeight || cssHeight;
    let img = this.img;

    // 如果图片未加载完成，等待加载后再初始化
    if (!img || !(img instanceof HTMLImageElement) || !img.width || !img.height) {
      if (img && img instanceof HTMLImageElement) {
        const onLoad = () => {
          img.removeEventListener('load', onLoad);
          this.initImg();
        };
        img.addEventListener('load', onLoad);
      }
      return;
    }

    let backingStoreRatio =
      this.ctx["webkitBackingStorePixelRatio"] ||
      this.ctx["mozBackingStorePixelRatio"] ||
      this.ctx["msBackingStorePixelRatio"] ||
      this.ctx["oBackingStorePixelRatio"] ||
      this.ctx["backingStorePixelRatio"] ||
      1;

    let ratio = devicePixelRatio / backingStoreRatio;
    let width = document.body.clientWidth;

    // if(width<=1600){
    //     ratio = 1;
    // }

    // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等

    cssWidth = (img.width / img.height) * cssHeight;

    this.canvas.style.width = cssWidth + "px";
    this.canvas.style.height = cssHeight + "px";

    this.canvas.width = cssWidth;
    this.canvas.height = cssHeight;
    this.canvasOrigWidth = cssWidth;
    this.canvasOrigHeight = cssHeight;

    // 由于画布扩大，canvas的坐标系也跟着扩大，如果按照原先的坐标系绘图内容会缩小
    // 所以需要将绘制比例放大

    // this.ctx.scale(ratio, ratio);

    let scaleX = cssWidth / img.width;
    let scaleY = cssHeight / img.height;

    this.canvas.style.display = "block";

    this.scaleX = scaleX;
    this.scaleY = scaleY;
    let arr = this.pointList.slice(0);
    this.updatePointList(arr);
    this.draw(false);
  };
  drawSpecialValue = () => {
    let pointList = this.pointList;
    let shoulderleft = pointList.filter((item) => {
      return item.part == "shoulderleft";
    })[0];
    let shoulderright = pointList.filter((item) => {
      return item.part == "shoulderright";
    })[0];

    let hipleft = pointList.filter((item) => {
      return item.part == "hipleft";
    })[0];
    let hipright = pointList.filter((item) => {
      return item.part == "hipright";
    })[0];

    if (!shoulderleft || !shoulderright || !hipleft || !hipright) {
      return;
    }

    let shldx = shoulderleft.position.x - hipleft.position.x;
    let shldy = shoulderleft.position.y - hipleft.position.y;

    let shrdx = shoulderright.position.x - hipright.position.x;
    let shrdy = shoulderright.position.y - hipright.position.y;

    let yx = (shoulderleft.position.y + hipleft.position.y) / 2;

    let shoulderDis = Math.sqrt(Math.pow(shldx, 2) + Math.pow(shldy, 2));
    let hipDis = Math.sqrt(Math.pow(shrdx, 2) + Math.pow(shrdy, 2));

    let p = +(Math.min(shoulderDis, hipDis) / Math.max(shoulderDis, hipDis)).toFixed(1);
    if (this.options.directon == "front") {
      // this.angles['scoliosisRadian'] =p.toFixed(1)
      dataAngle["scoliosisfront"] = p.toFixed(1);
      // this.drawText(p + "", this.canvas.width * 0.79, yx, hipleft);
      let kneeleft = pointList.filter((item) => {
        return item.part == "kneeleft";
      })[0];
      let kneeright = pointList.filter((item) => {
        return item.part == "kneeright";
      })[0];

      // let hip = pointList.filter((item) => { return item.part == "hipleft" })[0]
      let ankleleft = pointList.filter((item) => {
        return item.part == "ankleleft";
      })[0];
      let ankleright = pointList.filter((item) => {
        return item.part == "ankleright";
      })[0];

      let right = this.getAngle(kneeleft, hipleft, ankleleft);
      right = +((right / Math.PI) * 180).toFixed(1);
      dataAngle["keenfontright"] = right.toFixed(1);

      let left = this.getAngle(kneeright, hipright, ankleright);
      left = +((left / Math.PI) * 180).toFixed(1);
      dataAngle["keenfontleft"] = left.toFixed(1);
    }
    if (this.options.directon == "side" || this.options.directon == "otherSide") {
      let knee = pointList
        .filter((itemp) => {
          return itemp.part.indexOf("knee") >= 0;
        })
        .filter((k) => {
          return k.disabled;
        })[0];
      let hip = pointList
        .filter((itemp) => {
          return itemp.part.indexOf("hip") >= 0;
        })
        .filter((k) => {
          return k.disabled;
        })[0];
      let ankle = pointList
        .filter((itemp) => {
          return itemp.part.indexOf("ankle") >= 0;
        })
        .filter((k) => {
          return k.disabled;
        })[0];
      let r = this.getAngle(knee, hip, ankle);
      r = +((r / Math.PI) * 180).toFixed(1);
      dataAngle["keenside"] = r.toFixed(1);
      if (knee && knee.position) {
        let risks = this.risks.side.risks;
        let obj =
          risks.filter((r) => {
            return r.key == "kneehyperextension";
          })[0] || {};
        this.drawText(obj.raw.toFixed(1) + "°", this.canvas.width * 0.6, knee.position.y, knee);
      }
    }
  };
  getAngle = (origin: DotData, start: DotData, end: DotData): number => {
    if (!origin || !start || !end) {
      return 0;
    }
    let o = origin.position;
    let s = start.position;
    let e = end.position;

    let os = Math.atan2(s.y - o.y, s.x - o.x);
    let oe = Math.atan2(e.y - o.y, e.x - o.x);

    let radianAngle = Math.abs(oe - os);

    return radianAngle;
  };
  draw = (tag: boolean) => {
    if (!this.img.width) {
      return;
    }
    let ctx = this.ctx;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.save();

    this.drawImg();
    this.drawPointToPoint();
    this.drawSpecialValue();
    this.drawHorizotalLine();
    this.drawVerticalLine();
    this.drawDot();
    this.hoverDot();

    ctx.restore();
    this.angles = dataAngle;
    localStorage.setItem("angles", JSON.stringify(this.angles));
    window["pointList"] = this.pointList;

    if (tag) {
      const raf: any =
        window.requestAnimationFrame ||
        (window as any).webkitRequestAnimationFrame ||
        (window as any).mozRequestAnimationFrame ||
        (window as any).msRequestAnimationFrame ||
        function (cb: FrameRequestCallback) {
          return window.setTimeout(cb, 16) as unknown as number;
        };
      this.requestId = raf(this.draw.bind(this, true));
    }
  };
  drawText = (text: string, x: number, y: number, point: DotData) => {
    // let t = Math.abs(+text);
    let ctx = this.ctx;
    ctx.save();
    ctx.beginPath();
    // ctx.fillStyle = "red"
    ctx.fillStyle = point.hline.strokeStyle;
    if (this.options.canvasId.indexOf("big") >= 0) {
      ctx.font = "30px Arial";
    }
    ctx.textAlign = "left";
    ctx.textBaseline = "top";
    ctx.fillText(text + "", x, y);
    // let w = ctx.measureText(text+"")
    // ctx.arc(x+w.width+1, y,2,0,Math.PI*2)
    ctx.stroke();
    ctx.restore();
    ctx.closePath();
  };

  drawHorizotalLine = () => {
    let ctx = this.ctx;
    let dataList = this.pointList;
    for (let i = 0; i < dataList.length; i++) {
      let item = dataList[i];
      if (item.horizotalLine && item.horizotalLine.length >= 2 && item.horizotalLine[0] && item.horizotalLine[1]) {
        if (item.disabled) {
          ctx.save();
          ctx.beginPath();
          // ctx.strokeStyle = item.horizotalLine[0].line.strokeStyle
          ctx.strokeStyle = item.hline.strokeStyle;
          
          let pStart = item.horizotalLine[0].position;
          let pEnd = item.horizotalLine[1].position;

          let start = pStart.x < pEnd.x ? pStart : pEnd;
          let end = pStart.x < pEnd.x ? pEnd : pStart;

          let dx = end.x - start.x;
          let dy = end.y - start.y;

          if (dx == 0) {
            dx = 1;
          }
          let radian = dy / dx;

          let b = start.y - radian * start.x;
          let dgree = Math.atan2(dy, dx);
          let angle = (-dgree * 180) / Math.PI;
          let tx = this.canvas.width * 0.79;
          let ty = end.y;

          let startx = start.x;
          let endx = end.x;
          if (item.direction == "front") {
            startx = start.x * 0.8;
            endx = end.x * 1.2;
            this.drawDegValue("front", item, endx, ty);
            if (item.name == 'ankle'){
              this.drawText(angle.toFixed(1), endx, ty, item)
            }
          }
          if (item.direction == "back") {
            startx = start.x * 0.8;
            endx = end.x * 1.2;
            this.drawDegValue("back", item, endx, ty);
            // this.drawText(angle.toFixed(1), endx, ty, item)
          }
          if (item.direction == "side") {
            startx = startx - this.canvas.width * 0.002;
            endx = endx + this.canvas.width * 0.002;
            this.drawDegValue("side", item, tx, ty);
            // this.drawText(angle.toFixed(1), tx, ty, item)
          }
          if (item.direction == "otherSide") {
            startx = startx - this.canvas.width * 0.002;
            endx = endx + this.canvas.width * 0.002;
            this.drawDegValue("otherSide", item, tx, ty);
            // this.drawText(angle.toFixed(1), tx, ty, item)
          }
          dataAngle[item.name + item.direction] = angle.toFixed(1);
          let xend = startx * radian + b;
          let yend = endx * radian + b;

          ctx.moveTo(startx, xend);
          ctx.lineTo(endx, yend);
          ctx.stroke();
          ctx.closePath();
          ctx.restore();
        }
      }
    }
  };
  drawVerticalLine = () => {
    let ctx = this.ctx;
    let dataList = this.pointList;
    for (let i = 0; i < dataList.length; i++) {
      let item = dataList[i];
      if (item.verticalLine && item.verticalLine.length > 0 && item.verticalLine[0]) {
        if (item.disabled) {
          ctx.save();
          ctx.beginPath();
          ctx.strokeStyle = item.vline.strokeStyle;
          ctx.moveTo(item.verticalLine[0].position.x, 0);
          ctx.lineTo(item.verticalLine[0].position.x, this.canvas.height);
          ctx.stroke();
          ctx.closePath();
          ctx.restore();
        }
      }
    }
  };
  drawPointToPoint() {
    let ctx = this.ctx;
    let dataList = this.pointList;
    for (let i = 0; i < dataList.length; i++) {
      let item = dataList[i];
      if (item.lineChildren && item.lineChildren.length) {
        if (item.disabled) {
          for (let j = 0; j < item.lineChildren.length; j++) {
            if (item.lineChildren[j] && item.lineChildren[j].disabled) {
              ctx.save();
              ctx.beginPath();
              ctx.strokeStyle = item.lineChildren[j].line.strokeStyle;
              ctx.moveTo(item.position.x, item.position.y);
              ctx.lineTo(item.lineChildren[j].position.x, item.lineChildren[j].position.y);
              ctx.stroke();
              ctx.closePath();
              ctx.restore();
            }
          }
        }
      }
    }
  }
  drawImg = () => {
    let ctx = this.ctx;
    ctx.save();
    ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
    ctx.restore();
  };
  drawDot = () => {
    let data = this.pointList;
    let ctx = this.ctx;
    data.forEach((dItem) => {
      let selectRadius = 1;
      if (dItem.select || dItem.hover) {
        selectRadius = 2;
      }
      let position = dItem.position || { x: 0, y: 0 };
      if (dItem.disabled) {
        ctx.save();

        ctx.beginPath();
        ctx.fillStyle = dItem.dot.fillStyle;
        ctx.arc(+position.x, +position.y, dItem.dot.radius * selectRadius, 0, Math.PI * 2, false);

        ctx.closePath();
        ctx.fill();
        ctx.restore();

        ctx.beginPath();
        ctx.strokeStyle = dItem.circle.strokeStyle;
        ctx.arc(+position.x, +position.y, dItem.circle.radius * selectRadius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.stroke();
        //移动点时
        if (this.options.canvasId.indexOf("big") >= 0 && dItem.hover) {
          ctx.beginPath();
          ctx.textAlign = "start";
          ctx.textBaseline = "bottom";
          ctx.fillStyle = "red";
          ctx.font = "16px Arial";
          ctx.fillText(
            ponintName[dItem.part] || "",
            +position.x + dItem.circle.radius * 2,
            +position.y - dItem.circle.radius * 2
          );
          ctx.fill();
          ctx.closePath();
          ctx.stroke();
        }

        // ctx.restore();
      }
    });
  };

  drawDegValue = (flag, item, endx, ty) => {
    let key = "";
    if (flag === "front") {
      let risks = this.risks.front.risks;
      switch (item.name) {
        case "ear":
          key = "lateralhead";
          let obj =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty, item);
          break;
        case "shoulder":
          key = "unevenshoulder";
          let obj2 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj2?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty, item);
          break;
        case "hip":
          key = "scoliosis";
          let obj3 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText(((obj3?.raw ?? 0) * 100).toFixed(1) + "%", endx, ty - this.canvas.height * 0.03, item);
          key = "unevenhip";
          obj3 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj3?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty + this.canvas.height * 0.03, item);
          break;
        case "knee":
          key = "leg";
          let obj4 =
            risks.filter((r) => {
              return r.key.search(key) !== -1 && r.direction === "left";
            })[0] || {};
          this.drawText((obj4?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty - this.canvas.height * 0.03, item);
          obj4 =
            risks.filter((r) => {
              return r.key.search(key) !== -1 && r.direction === "right";
            })[0] || {};
          this.drawText((obj4?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty + this.canvas.height * 0.03, item);
          break;
      }
    } else if (flag === "side" || flag === "otherSide") {
      let risks = this.risks.side.risks;
      switch (item.name) {
        case "ear":
          key = "forwardhead";
          let obj =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj?.raw?.toFixed(1) ?? "N/A") + "°", endx * 0.8, ty, item);
          break;
        case "shoulder":
          key = "roundedshoulder";
          let obj2 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj2?.raw?.toFixed(1) ?? "N/A") + "°", endx * 0.8, ty, item);
          break;
        case "hip":
          key = "trunkforwardtilt";
          let obj3 =
              risks.filter((r) => {
                return r.key == key;
              })[0] || {};
          this.drawText((obj3?.raw?.toFixed(1) ?? "N/A") + "°", endx * 0.8, ty, item);
          break;
      }
    } else if (flag === "back") {
      let risks = this.risks.back.risks;
      switch (item.name) {
        case "ear":
          key = "lateralhead";
          let obj =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty, item);
          break;
        case "shoulder":
          key = "unevenshoulder";
          let obj2 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj2?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty, item);
          break;
        case "hip":
          key = "scoliosis";
          let obj3 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText(((obj3?.raw ?? 0) * 100).toFixed(1) + "%", endx, ty - this.canvas.height * 0.03, item);
          key = "unevenhip";
          obj3 =
            risks.filter((r) => {
              return r.key == key;
            })[0] || {};
          this.drawText((obj3?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty + this.canvas.height * 0.03, item);
          break;
        case "knee":
          key = "leg";
          let obj4 =
            risks.filter((r) => {
              return r.key.search(key) !== -1 && r.direction === "left";
            })[0] || {};
          this.drawText((obj4?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty - this.canvas.height * 0.03, item);
          obj4 =
            risks.filter((r) => {
              return r.key.search(key) !== -1 && r.direction === "right";
            })[0] || {};
          this.drawText((obj4?.raw?.toFixed(1) ?? "N/A") + "°", endx, ty + this.canvas.height * 0.03, item);
          break;
        case "ankle":
          let obj5 =
              this.risks.front.risks.filter((r) => {
              return r.key.search("ankleheelleft") !== -1 && r.direction === "left";
            })[0] || {};
          if (obj5?.raw !== undefined) {
            this.drawText(obj5.raw.toFixed(1) + "°", endx, ty - this.canvas.height * 0.03, item);
          }
          obj5 =
              this.risks.front.risks.filter((r) => {
              return r.key.search("ankleheelright") !== -1 && r.direction === "right";
            })[0] || {};
          if (obj5?.raw !== undefined) {
            this.drawText(obj5.raw.toFixed(1) + "°", endx, ty + this.canvas.height * 0.03, item);
          }
          break;
      }
    }
  };
  //计算两条线之间的夹角度数
  calculateAngleBetweenLines = (line1, line2) => {
    // 线1的向量
    const vec1 = {
      x: line1.x2 - line1.x1,
      y: line1.y2 - line1.y1
    };

    // 线2的向量
    const vec2 = {
      x: line2.x2 - line2.x1,
      y: line2.y2 - line2.y1
    };

    // 计算点积
    const dotProduct = vec1.x * vec2.x + vec1.y * vec2.y;

    // 计算向量长度
    const mag1 = Math.sqrt(vec1.x * vec1.x + vec1.y * vec1.y);
    const mag2 = Math.sqrt(vec2.x * vec2.x + vec2.y * vec2.y);

    // 计算夹角（弧度）
    const cosTheta = dotProduct / (mag1 * mag2);
    const angleRad = Math.acos(Math.min(Math.max(cosTheta, -1), 1)); // 确保值在[-1,1]范围内

    // 转换为度数
    const angleDeg = angleRad * (180 / Math.PI);

    return angleDeg;
  };
}
